<template>
<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/device-banner.png`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">终端安全解决方案</h2>
							<h4 class="text-left color-white">动态认证、深层防护</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">终端安全解决方案</h2>
				<div style="margin-top: 48px; font-size: 18px">
					提供多因素身份认证和动态身份认证能力；提供对终端环境的多层次安全评估能力；通过应用深层解析能力防护已知或未知漏洞；依托业务代理网关可提供业务敏感数据识别能力；基于身份的溯源分析能力，精准还原攻击行为。
				</div>
			</div>
		</div>


		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">统一身份融合</div>
										<div class="cont">与企业身份系统和SSO深度融合；支持多种身份认证方式；网络、应用、业务集中认证。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">终端管控能力</div>
										<div class="cont">终端环境感知；入侵防护检测；用户合规基线检测与修复；内置个性化策略编排。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">应用安全能力</div>
										<div class="cont">基于身份动态鉴权；应用内容安全水印；应用组粒度动态访问控制。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">优势价值</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="eee">
							<div class="t1">用户统一身份管理提供多因素身份认证和动态身份认证能力</div>
							<div class="t1">终端安全环境治理提供对终端环境的多层次安全评估能力</div>
							<div class="t1">应用系统未知漏洞防护通过应用深层解析能力防护已知或未知漏洞</div>
							<div class="t1">业务数据风险安全防护依托业务代理网关可提供业务敏感数据识别能力</div>
							<div class="t1">快速应急响应能力基于身份的溯源分析能力，精准还原攻击行为</div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/device1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			height: 80%;
			margin-top: 2%;
			text-align: left;
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			.t1 {
				font-size: 20px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}

.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		top: 70%;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
